module.exports = __webpack_public_path__ + "img/people-31.82a99119.png";